import React, { useState } from 'react';
import { Button, Grid } from 'antd';
import { SendOutlined, CheckOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import toast from 'react-hot-toast';
import PatientEmailModal from '../patient/PatientEmailModal';
import SendPatientInstructionsModal from './SendPatientInstructionsModal';

const SendPatientInstructionsButton = ({ note, noteContentRef, source }) => {
  const { t } = useTranslation();
  const { useBreakpoint } = Grid;
  const screens = useBreakpoint();
  const isMobile = screens.xs;
  const [showEmailModal, setShowEmailModal] = useState(false);
  const [showMessageModal, setShowMessageModal] = useState(false);
  const [hasSentInstructions, setHasSentInstructions] = useState(source.patientInstructionsSent());
  const [updatedPatient, setUpdatedPatient] = useState(null);

  const handleSendEmail = () => {
    if (!source.hasPatient()) {
      toast.error(t('send_patient_instructions.errors.no_patient'));
      return;
    }

    const patient = source.getPatient();
    if (!patient.getEmail()) {
      setShowEmailModal(true);
      return;
    }

    // Show message modal to edit the message
    setShowMessageModal(true);
  };

  const handleEmailSaved = (updatedPatient) => {
    setUpdatedPatient(updatedPatient);
    setShowEmailModal(false);
    setShowMessageModal(true);
  };

  const handleInstructionsSent = () => {
    setHasSentInstructions(true);
    setShowMessageModal(false);
    setUpdatedPatient(null); // Clear the updated patient
  };

  return (
    <>
      <Button
        type="default"
        icon={hasSentInstructions ? <CheckOutlined /> : <SendOutlined />}
        onClick={handleSendEmail}
        data-testid="send-patient-instructions-button"
        disabled={!note.isValid() || !source.hasPatient() || hasSentInstructions}
      >
        {hasSentInstructions
          ? t(isMobile ? 'send_patient_instructions.short_sent_label' : 'send_patient_instructions.sent_label')
          : t(isMobile ? 'send_patient_instructions.short_label' : 'send_patient_instructions.label')}
      </Button>

      <PatientEmailModal
        open={showEmailModal}
        onClose={() => setShowEmailModal(false)}
        patient={source.getPatient()}
        onEmailSaved={handleEmailSaved}
      />

      <SendPatientInstructionsModal
        open={showMessageModal}
        onClose={() => setShowMessageModal(false)}
        noteContentRef={noteContentRef}
        source={source}
        patient={updatedPatient}
        onInstructionsSent={handleInstructionsSent}
      />
    </>
  );
};

export default SendPatientInstructionsButton; 